module.exports = __webpack_public_path__ + "static/media/star-fg.b217e4d0.png";